export const environment = {
    // apiUrl: 'https://localhost:5711',
    //apiUrl: 'https://localhost:5001',
    apiUrl: 'https://hanagyan.ru/api',
    // apiUrl: 'https://vm-a4fdd9dc.na4u.ru:5711',
    token: 'YXV0aFRva2Vu',
    userAuthData: '1c0b8f3d4e2a9f8c7b6a5d4e3f2a1b0c9d8e7f6a5b4c3d2e1f0a9b8c7d6e5f4'
};

// authToken   Base64 YXV0aFRva2Vu
// UserId  Base64: VXNlcklk
// cookieConsent Base64 Y29va2llQ29uc2VudA== ​

